import { useMapContext } from '@rio-cloud/rio-uikit/MapContext';
import { useEffect } from 'react';

const HERE_IMPERIAL = 'imperial';
const HERE_METRIC = 'metric';

type UnitSystemAwareUi = {
    setUnitSystem?: (unitSystem: string) => void;
};

type MapScaleBarUnitsProps = {
    imperial: boolean;
};

const MapScaleBarUnits = ({ imperial }: MapScaleBarUnitsProps) => {
    const { api } = useMapContext();
    const ui: UnitSystemAwareUi | undefined = api.ui;

    useEffect(() => {
        if (typeof ui?.setUnitSystem !== 'function') {
            return;
        }

        ui.setUnitSystem(imperial ? HERE_IMPERIAL : HERE_METRIC);
    }, [ui, imperial]);

    return null;
};

export default MapScaleBarUnits;
